import React from 'react';
import { StarIcon, UsersIcon, HeartIcon } from 'lucide-react';
export function SocialProofBar() {
  return <section className="bg-coral-dark py-6 border-y border-coral/30" data-id="element-190">
      <div className="container mx-auto px-4 max-w-5xl fade-in-section" data-id="element-191">
        <div className="flex flex-col md:flex-row justify-center items-center gap-6 md:gap-12 text-white text-center" data-id="element-192">
          <div className="flex items-center gap-3" data-id="element-193">
            <UsersIcon className="text-rose w-6 h-6" data-id="element-194" />
            <span className="font-bold text-lg" data-id="element-195">
              3.247+ mujeres transformadas
            </span>
          </div>

          <div className="hidden md:block w-px h-8 bg-white/20" data-id="element-196"></div>

          <div className="flex items-center gap-3" data-id="element-197">
            <StarIcon className="text-yellow-400 fill-current w-6 h-6" data-id="element-198" />
            <span className="font-bold text-lg" data-id="element-199">4.8/5 valoración promedio</span>
          </div>

          <div className="hidden md:block w-px h-8 bg-white/20" data-id="element-200"></div>

          <div className="flex items-center gap-3" data-id="element-201">
            <HeartIcon className="text-rose w-6 h-6" data-id="element-202" />
            <span className="font-bold text-lg" data-id="element-203">97% tasa de satisfacción</span>
          </div>
        </div>
      </div>
    </section>;
}